import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '../../button/button.component';
import { InputComponent } from '../../input/input.component';
import { ProjectExtended } from '../../../../../../../libs/shared/src/lib/models/dashboard/user-from-be';
import { PROJECT_VALIDATION } from '../../../../../../../libs/shared/src/lib/constants/validation-constants';
import { ValidationService } from '../../../../../../../libs/shared/src/lib/services/validation.service';

@Component({
  selector: 'app-project-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent, InputComponent, TranslocoPipe],
  templateUrl: './project-form.component.html',
  styleUrls: ['./project-form.component.scss'],
})
export class ProjectFormComponent implements OnInit, OnChanges {
  @Input() editingProject: ProjectExtended | null = null;
  @Input() editingIndex: number | null = null;

  @Output() save = new EventEmitter<Partial<ProjectExtended>>();
  @Output() cancel = new EventEmitter<void>();

  projectForm: FormGroup;

  // Expose validation constants to template
  readonly VALIDATION = PROJECT_VALIDATION;

  constructor(
    private fb: FormBuilder,
    private validationService: ValidationService
  ) {
    this.projectForm = this.createForm();
  }

  ngOnInit(): void {
    if (this.editingProject) {
      this.populateForm(this.editingProject);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editingProject'] && changes['editingProject'].currentValue) {
      this.populateForm(changes['editingProject'].currentValue);
    }
  }

  /**
   * Create the form with validation
   * @returns FormGroup
   */
  private createForm(): FormGroup {
    const validators = this.validationService.getProjectValidators();
    return this.fb.group({
      title: ['', validators.title],
      position: ['', validators.position],
      duration: [null, validators.duration],
      country: ['', validators.country],
    });
  }

  private populateForm(project: ProjectExtended): void {
    this.projectForm.patchValue({
      title: project.title || '',
      position: project.position || '',
      duration: project.duration || null,
      country: project.country || '',
    });
  }

  /**
   * Submit the form
   */
  onSubmit(): void {
    if (this.projectForm.invalid) {
      this.projectForm.markAllAsTouched();
      return;
    }

    const formValue = this.projectForm.getRawValue();

    // Create the project object
    const project: Partial<ProjectExtended> = {
      id: this.editingProject?.id,
      title: formValue.title,
      position: formValue.position,
      duration: formValue.duration,
      country: formValue.country,
    };

    this.save.emit(project);
  }
}
